import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Global } from '../service/core/Global';

@Pipe({
  name: 'safeUrl',
  standalone: true
})
export class SafeUrlPipe implements PipeTransform {
  private sanitizer = inject(DomSanitizer);

  transform(url: string | null | undefined): SafeResourceUrl {
    if (!url) return '';
    
    // Si es una ruta relativa de la API, le concatenamos la URL base
    const fullUrl = url.startsWith('http') ? url : (Global.url + url);
    return this.sanitizer.bypassSecurityTrustResourceUrl(fullUrl);
  }
}
